import i18n, { TFunction } from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEs from './translations/translations.es.json';
import translationsEn from './translations/translations.en.json';
import translationsIt from './translations/translations.it.json';
import { GetLocale } from "@cuatroochenta/co-admin-react-library";

export const Languages = {
    en: 'en',
    es: 'es',
    it: 'it'
};

const region = process.env.REACT_APP_REGION;

i18n.use(initReactI18next).init({
    resources: {
        en: translationsEn,
        es: translationsEs,
        it: translationsIt
    },
    lng: region,
    fallbackLng: "en",

    interpolation: {
        escapeValue: false,
    },
});

const translate = (t: TFunction, key: string, params?: {}) => t(key, { lng: GetLocale(), ...params });

export { i18n, translate };